import { render, staticRenderFns } from "./committee.vue?vue&type=template&id=899e5640"
import script from "./committee.vue?vue&type=script&lang=js"
export * from "./committee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('899e5640')) {
      api.createRecord('899e5640', component.options)
    } else {
      api.reload('899e5640', component.options)
    }
    module.hot.accept("./committee.vue?vue&type=template&id=899e5640", function () {
      api.rerender('899e5640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/moc/committee.vue"
export default component.exports